/**
=========================================================
* Trust Cargo - the row's database id
=========================================================

* Every list shows the record's real auto-increment id in its first column.
*
* It is the number to quote when something has to be looked up or corrected
* directly in the database, so it is deliberately the same everywhere - one
* component rather than eleven slightly different columns.
*
* Set in muted, tabular figures: present when you go looking for it, quiet
* enough not to compete with the name or the code beside it.
*/

import PropTypes from "prop-types";
import TableCell from "@mui/material/TableCell";
import SuiTypography from "components/SuiTypography";

/** The heading. */
export function IdHead() {
  return (
    <TableCell align="center" sx={{ width: 70 }}>
      ID
    </TableCell>
  );
}

/** The value. */
function IdCell({ value }) {
  return (
    <TableCell align="center" sx={{ width: 70 }}>
      <SuiTypography
        sx={({ palette, functions: { rgba } }) => ({
          fontSize: 13,
          fontWeight: 700,
          fontVariantNumeric: "tabular-nums",
          color: rgba(palette.dark.main, 0.5),
        })}
      >
        {value ?? "-"}
      </SuiTypography>
    </TableCell>
  );
}

IdCell.defaultProps = { value: null };
IdCell.propTypes = { value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]) };

export default IdCell;
